/*
 * callec-plp-filter.js — コレクションページ改修 S-037 段階2(2026-10-07)
 * 方式A: Search & Discovery・collection.filters は使わず、ブラウザで絞り込みと件数を計算する。
 *
 *   データ   : <collection.url>?view=plp-data&page=N(templates/collection.plp-data.liquid、250 件ずつ)
 *              タブ内(sessionStorage)に 10 分保持。読むのは「表示が落ち着いた後」「バーに触れた時」「条件付き URL で来た時」
 *   一覧     : 絞り込み後の商品 ID を /search?q=id:… OR …&section_id=callec-plp-cards で通常のカードとして描く(24 件ずつ)
 *              条件が無くなったら、サーバーが描いた元の一覧に戻す
 *   件数     : 同じ項目内は「いずれか」、項目をまたぐと「すべて」。各選択肢の件数は「その選択肢だけにしたらいくつか」
 *              (デモ template.html の matches / cntOne と同じ計算)
 *   価格     : 最小 / 最大の数値入力(円・空欄可。最小>最大は入れ替えて適用)。判定は商品の最安価格
 *   バー     : 選んだ条件をバーの中に横スクロールで出す(×で外す・最後に「すべて解除」)
 *   URL      : ?size=M,L&color=BLACK&type=ボトムス&price=10000-19999&sort=low(price は 10000- / -9999 も可)。読み込み時に復元。条件付きは noindex
 *   計測     : Shopify.analytics.publish('callec:plp_filter_open' / plp_filter_apply / plp_sort_change / plp_filter_zero)
 */
(function () {
  'use strict';

  var CARDS_SECTION = 'callec-plp-cards';
  var CACHE_MS = 10 * 60 * 1000;
  var KEYS = ['size', 'color', 'type']; // 選択肢で選ぶ項目。価格は数値入力で別扱い
  var LABELS = { size: 'サイズ', color: 'カラー', type: 'カテゴリ', price: '価格', sort: '並び替え' }; // 2026-10-07 色→カラー
  var ALIASES = {
    size: ['SIZE', 'サイズ'],
    color: ['COLOR', 'COLOUR', '色', 'カラー'],
    type: ['カテゴリ', 'カテゴリー', 'TYPE', '商品タイプ', 'CATEGORY'],
    price: ['金額', '価格', 'PRICE'],
    sort: ['並び替え', '並べ替え', 'SORT']
  };
  var SORTS = [
    ['rec', 'おすすめ'],
    ['new', '新着順'],
    ['low', '価格の安い順'],
    ['high', '価格の高い順']
  ];
  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL', 'FREE'];
  var MORE_AFTER = 10; // 11 個目以降は「さらに表示」

  /* ---------- 小さな道具 ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function yen(n) { return '¥' + Number(n).toLocaleString('ja-JP'); }
  function uniq(arr) {
    var seen = {}, out = [];
    arr.forEach(function (x) { if (x && !seen[x]) { seen[x] = 1; out.push(x); } });
    return out;
  }
  function listOf(text) {
    return String(text || '').split(/[,、\n]/).map(function (x) { return x.trim(); }).filter(Boolean);
  }
  function keysFromNames(text) {
    var names = listOf(text).map(function (x) { return x.toUpperCase(); });
    var out = {};
    Object.keys(ALIASES).forEach(function (k) {
      if (ALIASES[k].some(function (a) { return names.indexOf(a.toUpperCase()) !== -1; })) out[k] = true;
    });
    return out;
  }

  /* ---------- 条件 ---------- */
  function emptyState() {
    return { size: new Set(), color: new Set(), type: new Set(), price: { min: null, max: null }, sort: 'rec' };
  }
  function cloneState(f) {
    return {
      size: new Set(f.size), color: new Set(f.color), type: new Set(f.type),
      price: { min: f.price.min, max: f.price.max }, sort: f.sort
    };
  }
  function hasPrice(f) { return f.price.min !== null || f.price.max !== null; }
  function filterCount(f) { return f.size.size + f.color.size + f.type.size + (hasPrice(f) ? 1 : 0); }
  function activeCount(f) { return filterCount(f) + (f.sort !== 'rec' ? 1 : 0); }
  /* 最小>最大なら入れ替える(新しいオブジェクトを返す) */
  function normPrice(pr) {
    if (pr.min !== null && pr.max !== null && pr.min > pr.max) return { min: pr.max, max: pr.min };
    return { min: pr.min, max: pr.max };
  }
  function priceParam(pr) {
    return (pr.min !== null ? pr.min : '') + '-' + (pr.max !== null ? pr.max : '');
  }
  function priceLabel(pr) {
    var p = normPrice(pr);
    return (p.min !== null ? yen(p.min) : '') + '〜' + (p.max !== null ? yen(p.max) : '');
  }
  /* 全角数字も受け付け、数字以外は捨てる。空なら null */
  function toYen(text) {
    var d = String(text || '').replace(/[０-９]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 0xfee0); })
      .replace(/[^\d]/g, '');
    return d ? Number(d) : null;
  }
  function filterList(f) {
    var out = [];
    KEYS.forEach(function (k) { f[k].forEach(function (v) { out.push(k + '=' + v); }); });
    if (hasPrice(f)) out.push('price=' + priceParam(normPrice(f.price)));
    return out;
  }
  function sameFilters(a, b) { return filterList(a).join('|') === filterList(b).join('|'); }

  function sizeRank(s) {
    var i = SIZE_ORDER.indexOf(String(s).toUpperCase());
    if (i !== -1) return i;
    var n = parseFloat(String(s).replace(/[^\d.]/g, ''));
    return 100 + (isNaN(n) ? 999 : n);
  }

  /* ---------- 1 つのコレクションの絞り込み ---------- */
  function Plp(bar) {
    this.bar = bar;
    this.sid = bar.dataset.sectionId;
    var cfgEl = bar.parentNode.querySelector('[data-cplp-f-config]') || $('[data-cplp-f-config]');
    this.cfg = JSON.parse(cfgEl.textContent);
    this.box = bar.closest('product-grid-container') || bar.parentNode;
    this.grid = $('[data-products-grid]', this.box);
    /* もっと見る・復元の部品(callec-plp-more.js、先に読み込まれる) */
    this.mc = this.box.__cplpMore || null;
    this.empty = $('[data-cplp-f-empty]', this.box);
    this.applied = this.box.querySelector('[data-cplp-f-applied]');
    this.sheet = document.getElementById('CplpFilter-' + this.sid);
    this.hidden = keysFromNames(this.cfg.hide);
    this.openGroups = keysFromNames(this.cfg.open);
    this.swatches = this.parseSwatches(this.cfg.swatches);
    this.state = emptyState();
    this.draft = null;
    this.data = null;
    this.dataPromise = null;
    this.original = null;
    this.results = [];
    this.shown = 0;
    this.req = 0;
    this.zeroSig = '';
    this.urlPage = Number(new URLSearchParams(location.search).get('page')) || 1;
    this.init();
  }

  Plp.prototype.parseSwatches = function (text) {
    var map = {};
    String(text || '').split(/[\n,]/).forEach(function (line) {
      var i = line.indexOf(':');
      if (i < 1) return;
      var v = line.slice(i + 1).trim();
      if (v.charAt(0) === '#') map[line.slice(0, i).trim().toLowerCase()] = v;
    });
    return map;
  };

  Plp.prototype.publish = function (name, data) {
    try {
      if (!(window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function')) return;
      Shopify.analytics.publish(name, Object.assign({}, data, {
        collection_handle: this.cfg.handle,
        template: this.cfg.template,
        products_count: this.cfg.total
      }));
    } catch (e) { /* 計測の失敗で操作を止めない */ }
  };

  /* ---------- データ ---------- */
  Plp.prototype.cacheKey = function () { return 'cplp:d:' + this.cfg.handle; };

  Plp.prototype.readCache = function () {
    try {
      var c = JSON.parse(sessionStorage.getItem(this.cacheKey()) || 'null');
      if (c && c.at && Date.now() - c.at < CACHE_MS && Array.isArray(c.p)) return c.p;
    } catch (e) { /* 使えない環境では毎回取る */ }
    return null;
  };

  Plp.prototype.writeCache = function (rows) {
    try { sessionStorage.setItem(this.cacheKey(), JSON.stringify({ at: Date.now(), p: rows })); } catch (e) { /* 容量超過は記憶しないだけ */ }
  };

  Plp.prototype.fetchPage = function (n) {
    var url = this.cfg.url + '?view=plp-data&page=' + n;
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('plp-data ' + r.status);
      return r.json();
    });
  };

  Plp.prototype.loadData = function () {
    var self = this;
    if (this.dataPromise) return this.dataPromise;
    var t0 = performance.now();
    var cached = this.readCache();
    /* 件数はページに出ているので、必要なページ数を先に決めて同時に取る(611 点なら 3 回) */
    var guess = Math.max(1, Math.ceil((this.cfg.total || 1) / 250));
    var p = cached ? Promise.resolve({ rows: cached, fetches: 0 }) : Promise.all(
      Array.apply(null, Array(guess)).map(function (_, i) { return self.fetchPage(i + 1); })
    ).then(function (pages) {
      var more = [];
      /* 表示後に商品が増えていた場合だけ、足りないページを追加で取る */
      for (var i = guess + 1; i <= (pages[0].pages || 1); i++) more.push(self.fetchPage(i));
      return Promise.all(more).then(function (extra) {
        var rows = [];
        pages.concat(extra).forEach(function (pg) { rows = rows.concat(pg.p || []); });
        self.writeCache(rows);
        return { rows: rows, fetches: pages.length + extra.length };
      });
    });
    this.dataPromise = p.then(function (res) {
      self.data = res.rows.map(function (r, i) {
        var v = (r[5] || []).map(function (x) { return { c: x[0], s: x[1], a: x[2] }; });
        return {
          id: r[0], h: r[1], t: r[2], p: r[3], a: r[4], v: v, i: i,
          sizes: uniq(v.map(function (x) { return x.s; })),
          colors: uniq(v.map(function (x) { return x.c; }))
        };
      });
      /* 確認用: 取得回数・時間・件数 */
      window.__cplpData = { fetches: res.fetches, ms: Math.round(performance.now() - t0), count: self.data.length };
      self.onData();
      return self.data;
    }).catch(function (err) {
      self.dataPromise = null;
      self.dataError = true;
      self.onDataError();
      throw err;
    });
    return this.dataPromise;
  };

  /* ---------- 計算(デモと同じ) ---------- */
  Plp.prototype.matches = function (p, f) {
    if (f.size.size && !p.sizes.some(function (s) { return f.size.has(s); })) return false;
    if (f.color.size && !p.colors.some(function (c) { return f.color.has(c); })) return false;
    if (f.type.size && !f.type.has(p.t)) return false;
    if (hasPrice(f)) {
      var pr = normPrice(f.price);
      if (pr.min !== null && p.p < pr.min) return false;
      if (pr.max !== null && p.p > pr.max) return false;
    }
    return true;
  };

  Plp.prototype.compute = function (f) {
    var self = this;
    var r = this.data.filter(function (p) { return self.matches(p, f); });
    var by = {
      new: function (a, b) { return b.id - a.id || a.i - b.i; },
      low: function (a, b) { return a.p - b.p || a.i - b.i; },
      high: function (a, b) { return b.p - a.p || a.i - b.i; }
    }[f.sort];
    return by ? r.sort(by) : r;
  };

  Plp.prototype.countOne = function (f, key, val) {
    var g = cloneState(f);
    g[key] = new Set([val]);
    var self = this, n = 0;
    this.data.forEach(function (p) { if (self.matches(p, g)) n++; });
    return n;
  };

  /* コレクションにある値(サイズ順・多い順) */
  Plp.prototype.facetValues = function () {
    var d = this.data, freq = {};
    d.forEach(function (p) { p.colors.forEach(function (c) { freq[c] = (freq[c] || 0) + 1; }); });
    var sizes = uniq([].concat.apply([], d.map(function (p) { return p.sizes; })))
      .sort(function (a, b) { return sizeRank(a) - sizeRank(b); });
    var colors = Object.keys(freq).sort(function (a, b) { return freq[b] - freq[a]; });
    var types = uniq(d.map(function (p) { return p.t; }));
    var self = this;
    var prices = d.map(function (p) { return p.p; });
    var out = { size: sizes, color: colors, type: types };
    /* 値が 1 種類しかない項目・設定で隠した項目は出さない */
    KEYS.forEach(function (k) { if (out[k].length < 2 || self.hidden[k]) out[k] = []; });
    out.priceRange = uniq(prices.map(String)).length < 2 || this.hidden.price
      ? null : [Math.min.apply(null, prices), Math.max.apply(null, prices)];
    return out;
  };

  Plp.prototype.label = function (key, val) {
    return val;
  };

  /* ---------- URL ---------- */
  Plp.prototype.readUrl = function () {
    var q = new URLSearchParams(location.search);
    var f = emptyState();
    KEYS.forEach(function (k) {
      listOf(q.get(k) || '').forEach(function (v) { f[k].add(v); });
    });
    var m = String(q.get('price') || '').match(/^\s*(\d*)\s*-\s*(\d*)\s*$/);
    if (m) f.price = normPrice({ min: m[1] ? Number(m[1]) : null, max: m[2] ? Number(m[2]) : null });
    var s = q.get('sort');
    if (s && SORTS.some(function (x) { return x[0] === s; })) f.sort = s;
    return f;
  };

  Plp.prototype.writeUrl = function () {
    var q = new URLSearchParams(location.search);
    ['size', 'color', 'type', 'price', 'sort', 'page'].forEach(function (k) { q.delete(k); });
    var f = this.state, parts = [];
    var enc = function (v) { return encodeURIComponent(v).replace(/%2C/gi, ','); };
    KEYS.forEach(function (k) {
      if (f[k].size) parts.push(k + '=' + Array.from(f[k]).map(enc).join(','));
    });
    if (hasPrice(f)) parts.push('price=' + priceParam(normPrice(f.price)));
    if (f.sort !== 'rec') parts.push('sort=' + f.sort);
    /* 条件なしに戻したら、元の一覧で読み込み済みのページ番号に戻す(条件を変えたら 1 ページ目から) */
    if (!activeCount(f) && this.mc && this.mc.last > 1) parts.push('page=' + this.mc.last);
    var rest = q.toString();
    var qs = (rest ? rest + (parts.length ? '&' : '') : '') + parts.join('&');
    var url = location.pathname + (qs ? '?' + qs : '') + location.hash;
    if (url !== location.pathname + location.search + location.hash) {
      history.pushState({ cplp: 1 }, '', url);
    }
  };

  Plp.prototype.setRobots = function (on) {
    var m = document.head.querySelector('meta[name="robots"][data-cplp]');
    if (on && !m) {
      if (document.head.querySelector('meta[name="robots"]')) return; // 既に指定があるページは触らない
      m = document.createElement('meta');
      m.name = 'robots';
      m.content = 'noindex,follow';
      m.setAttribute('data-cplp', '');
      document.head.appendChild(m);
    } else if (!on && m) {
      m.remove();
    }
  };

  /* ---------- バー・適用中チップ ---------- */
  Plp.prototype.renderBar = function () {
    var f = this.state, n = activeCount(f);
    var badge = $('[data-cplp-f-badge]', this.bar);
    if (badge) { badge.hidden = !n; badge.textContent = n; }
    var count = this.data && activeCount(f) ? this.results.length : this.cfg.total;
    $('[data-cplp-f-count]', this.bar).textContent = count + '件';
    var sel = $('[data-cplp-f-sort]', this.bar);
    if (sel) {
      sel.value = f.sort;
      var face = $('[data-cplp-f-sort-face]', this.bar); // スマホのバーに出す今の並び順(2026-10-27)
      // 狭い端末で収まるよう「価格の」を外す(安い順 / 高い順)
      if (face && sel.selectedIndex > -1) face.textContent = sel.options[sel.selectedIndex].text.replace(/^価格の/, '');
    }
    this.renderApplied();
  };

  Plp.prototype.renderApplied = function () {
    var f = this.state, self = this, html = '';
    var chip = function (k, v, text) {
      html += '<button type="button" class="cplp-applied__chip" data-rm="' + esc(k) + '" data-v="' + esc(v) +
        '" aria-label="' + esc(text) + ' を外す">' + esc(text) + '<span aria-hidden="true">×</span></button>';
    };
    KEYS.forEach(function (k) {
      f[k].forEach(function (v) { chip(k, v, LABELS[k] + ': ' + self.label(k, v)); });
    });
    if (hasPrice(f)) chip('price', '', LABELS.price + ': ' + priceLabel(f.price));
    if (html) html += '<button type="button" class="cplp-applied__clear" data-cplp-f-clear>すべて解除</button>';
    this.applied.innerHTML = html;
    this.applied.hidden = !html;
  };

  Plp.prototype.announce = function (text) {
    var live = $('[data-cplp-f-live]', this.bar);
    if (!live) return;
    clearTimeout(this.liveTimer);
    this.liveTimer = setTimeout(function () { live.textContent = text; }, 300);
  };

  /* ---------- 一覧の差し替え ---------- */
  Plp.prototype.fetchCards = function (items) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var q = items.map(function (p) { return 'id:' + p.id; }).join(' OR ');
    var url = root + 'search?type=product&options%5Bunavailable_products%5D=show&options%5Bprefix%5D=none&q=' +
      encodeURIComponent(q) + '&section_id=' + CARDS_SECTION;
    var parse = function (html) {
      var map = {};
      new DOMParser().parseFromString(html, 'text/html').querySelectorAll('[data-cplp-pid]').forEach(function (n) {
        /* 検索結果として描いたカードのリンクには検索の計測用パラメータ(_pos/_sid/_ss)が付くので外す */
        n.querySelectorAll('a[href*="_sid="]').forEach(function (a) {
          a.setAttribute('href', a.getAttribute('href').replace(/([?&])_(pos|sid|ss)=[^&#]*/g, '$1').replace(/[?&]+(#|$)/, '$1').replace(/\?&+/, '?').replace(/&{2,}/g, '&'));
        });
        map[n.getAttribute('data-cplp-pid')] = n;
      });
      return map;
    };
    var get = function (u) {
      return fetch(u, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('cards ' + r.status);
        return r.text();
      });
    };
    return get(url).then(function (html) {
      var map = parse(html);
      /* 検索に出ない商品は商品ページから 1 件ずつ描く */
      var missing = items.filter(function (p) { return !map[p.id] && p.h; });
      return Promise.all(missing.map(function (p) {
        return get(root + 'products/' + encodeURIComponent(p.h) + '?section_id=' + CARDS_SECTION)
          .then(function (h) { Object.assign(map, parse(h)); })
          .catch(function () { /* 描けない 1 件は飛ばす */ });
      })).then(function () {
        return items.map(function (p) { return map[p.id]; }).filter(Boolean);
      });
    });
  };

  Plp.prototype.saveOriginal = function () {
    if (this.original || !this.grid) return;
    this.original = Array.prototype.slice.call(this.grid.children);
  };

  Plp.prototype.restoreOriginal = function () {
    this.req++;
    this.box.classList.remove('is-cplp-loading');
    if (this.original && this.grid) {
      this.grid.replaceChildren.apply(this.grid, this.original);
    }
    this.original = null;
    if (this.grid) this.grid.hidden = false;
    if (this.mc) this.mc.setBase();
    this.empty.hidden = true;
    this.results = [];
  };

  Plp.prototype.perPage = function () { return (this.mc && this.mc.per) || 24; };

  /* 条件付きの一覧を描く。reset=true なら最初から upto 件(既定 1 回分)、false なら続きを 1 回分足す */
  Plp.prototype.showPage = function (reset, upto) {
    var self = this, size = this.perPage();
    var from = reset ? 0 : this.shown;
    var slice = this.results.slice(from, from + (reset ? (upto || size) : size));
    var req = ++this.req;
    var chunks = [];
    for (var i = 0; i < slice.length; i += size) chunks.push(slice.slice(i, i + size));
    if (reset) this.box.classList.add('is-cplp-loading');
    else if (this.mc) { this.mc.setBusy(true); this.mc.addSkeletons(slice.length, false); }
    return Promise.all(chunks.map(function (c) { return self.fetchCards(c); })).then(function (lists) {
      if (req !== self.req) return;
      var nodes = [].concat.apply([], lists);
      if (reset) {
        var frag = document.createDocumentFragment();
        nodes.forEach(function (n) { frag.appendChild(document.importNode(n, true)); });
        self.grid.replaceChildren(frag);
      } else if (self.mc) {
        self.mc.fillSkeletons(nodes);
      }
      self.shown = from + slice.length;
      self.box.classList.remove('is-cplp-loading');
      self.renderMore();
      if (!reset) {
        var page = Math.ceil(self.shown / size);
        if (self.mc) history.replaceState(history.state, '', self.urlWithPage(page));
        if (self.mc) self.mc.announce(nodes.length + '件追加しました。' + self.results.length + '件中' + self.shown + '件を表示');
        self.publish('callec:plp_load_more', { page_loaded: page, shown_count: self.shown, total_count: self.results.length });
      }
    }).catch(function () {
      if (req !== self.req) return;
      if (self.mc) self.mc.removeSkeletons();
      self.box.classList.remove('is-cplp-loading');
      self.renderMore('読み込めませんでした。もう一度お試しください');
    });
  };

  Plp.prototype.urlWithPage = function (n) {
    var q = new URLSearchParams(location.search);
    q.delete('page');
    var qs = q.toString().replace(/%2C/gi, ',');
    if (n > 1) qs += (qs ? '&' : '') + 'page=' + n;
    return location.pathname + (qs ? '?' + qs : '') + location.hash;
  };

  Plp.prototype.renderMore = function (error) {
    if (!this.mc) return;
    this.mc.renderFilter({ total: this.results.length, shown: this.shown, error: error || '' });
  };

  Plp.prototype.renderEmpty = function () {
    this.grid.replaceChildren();
    if (this.mc) this.mc.hide();
    this.empty.innerHTML = '<p>条件に合う商品がありません。</p><p class="cplp-fempty__sub">' +
      esc(this.cfg.zeroHint || '条件を1つ外すと見つかるかもしれません') + '</p>' +
      '<button type="button" class="cplp-btn-outline" data-cplp-f-clear>すべて解除</button>';
    this.empty.hidden = false;
  };

  /* 条件を一覧に反映する。push=true なら URL を積む */
  Plp.prototype.apply = function (push) {
    var self = this;
    var active = activeCount(this.state) > 0;
    this.setRobots(active);
    if (push) this.writeUrl();
    if (!active) {
      this.restoreOriginal();
      this.renderBar();
      this.announce(this.cfg.total + '件');
      return Promise.resolve();
    }
    this.box.classList.add('is-cplp-loading');
    return this.loadData().then(function () {
      self.results = self.compute(self.state);
      self.renderBar();
      self.announce(self.results.length + '件');
      self.saveOriginal();
      self.empty.hidden = true;
      if (!self.results.length) {
        self.box.classList.remove('is-cplp-loading');
        self.req++;
        self.renderEmpty();
        return;
      }
      /* URL の page(条件付きで「◯回分読み込み済み」)まで一度に描く。戻ったときの復元にも使う */
      var upto = self.pendingPage > 1 ? self.pendingPage * self.perPage() : 0;
      self.pendingPage = 0;
      return self.showPage(true, upto);
    }).catch(function () {
      self.box.classList.remove('is-cplp-loading');
    });
  };

  Plp.prototype.scrollToList = function () {
    var pinned = document.body.classList.contains('header-pinned');
    var hh = pinned ? parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--f-header-height')) || 0 : 0;
    var top = this.bar.parentNode.getBoundingClientRect().top + window.scrollY - hh;
    if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'auto' });
  };

  /* ---------- シート ---------- */
  Plp.prototype.openSheet = function (opener) {
    var self = this;
    if (!this.sheet) return;
    this.draft = cloneState(this.state);
    this.zeroSig = '';
    var open = function () {
      self.sheet.openDrawer(opener);
      /* 開いたら見出しへフォーカス(テーマ部品は生成時に見出しを見つけられないため、ここで当てる) */
      var title = self.sheet.querySelector('.cplp-fsheet__title');
      if (title) setTimeout(function () { title.focus({ preventScroll: true }); }, 30);
      self.publish('callec:plp_filter_open', { from: 'bar' });
    };
    if (typeof this.sheet.openDrawer === 'function') open();
    else customElements.whenDefined('drawer-component').then(open);
    if (this.data) this.buildSheet();
    else {
      this.setSheetLoading(true);
      this.loadData().catch(function () { /* onDataError が表示する */ });
    }
  };

  Plp.prototype.setSheetLoading = function (on) {
    if (!this.sheet) return;
    this.sheet.classList.toggle('is-loading', on);
    var msg = $('[data-cplp-f-msg]', this.sheet);
    if (on && !msg) {
      $('[data-cplp-f-body]', this.sheet).innerHTML = '<p class="cplp-fsheet__msg" data-cplp-f-msg>読み込み中…</p>';
    }
    $('[data-cplp-f-apply]', this.sheet).disabled = on;
  };

  Plp.prototype.priceHtml = function (range) {
    var field = function (k, label, ph) {
      return '<label class="cplp-price__field"><span class="cplp-price__label">' + label + '</span>' +
        '<input type="text" inputmode="numeric" autocomplete="off" enterkeyhint="done" data-cplp-price="' + k +
        '" placeholder="' + esc(ph) + '" aria-label="' + label + 'の価格(円)"><span class="cplp-price__unit">円</span></label>';
    };
    return '<div class="cplp-price">' + field('min', '最小', '下限なし') + '<span class="cplp-price__sep" aria-hidden="true">〜</span>' +
      field('max', '最大', '上限なし') + '</div>' +
      '<p class="cplp-price__note" data-cplp-price-swap hidden>最小が最大より大きいため、入れ替えて絞り込みます</p>' +
      '<p class="cplp-price__range">この一覧の価格: ' + yen(range[0]) + '〜' + yen(range[1]) + '</p>';
  };

  Plp.prototype.syncPriceInputs = function () {
    if (!this.sheet || !this.draft) return;
    var pr = this.draft.price;
    $all('[data-cplp-price]', this.sheet).forEach(function (inp) {
      var v = pr[inp.dataset.cplpPrice];
      inp.value = v === null ? '' : String(v);
    });
  };

  Plp.prototype.groupHtml = function (key, title, inner, count, noteText) {
    var open = this.openGroups[key] ? ' open' : '';
    var note = key === 'sort' ? '' : '<small>' + esc(noteText || '複数選べます') + '</small>';
    return '<details class="cplp-fgroup" data-group="' + key + '"' + open + '>' +
      '<summary class="cplp-fgroup__head"><span>' + esc(title) + '</span>' + note + '</summary>' +
      '<div class="cplp-fgroup__body">' + inner + (count > MORE_AFTER
        ? '<button type="button" class="cplp-fgroup__more" data-cplp-f-showmore>さらに表示(' + (count - MORE_AFTER) + ')</button>'
        : '') + '</div></details>';
  };

  Plp.prototype.optHtml = function (key, val, idx) {
    var sw = '';
    if (key === 'color') {
      var hex = this.swatches[String(val).toLowerCase()];
      sw = '<span class="cplp-opt__sw"' + (hex ? ' style="background:' + esc(hex) + '"' : '') + '></span>';
    }
    return '<button type="button" class="cplp-opt' + (idx >= MORE_AFTER ? ' is-extra' : '') + '" data-k="' + key +
      '" data-v="' + esc(val) + '" aria-pressed="false"><span class="cplp-opt__box" aria-hidden="true"></span>' + sw +
      '<span class="cplp-opt__label">' + esc(this.label(key, val)) + '</span><span class="cplp-opt__n"></span></button>';
  };

  Plp.prototype.buildSheet = function () {
    var self = this, vals = this.facetValues(), html = '';
    var radios = SORTS.map(function (s) {
      var label = s[0] === 'rec' ? (self.cfg.sortRecLabel || s[1]) : s[1];
      return '<label class="cplp-opt cplp-opt--radio"><input type="radio" name="cplp-sort-' + esc(self.sid) +
        '" value="' + s[0] + '"><span class="cplp-opt__label">' + esc(label) + '</span></label>';
    }).join('');
    if (!this.hidden.sort && $('[data-cplp-f-sort]', this.bar)) html += this.groupHtml('sort', LABELS.sort, radios, 0);
    KEYS.forEach(function (k) {
      if (!vals[k].length) return;
      var inner = vals[k].map(function (v, i) { return self.optHtml(k, v, i); }).join('');
      html += self.groupHtml(k, LABELS[k], inner, vals[k].length);
    });
    if (vals.priceRange) html += this.groupHtml('price', LABELS.price, this.priceHtml(vals.priceRange), 0, '円・半角数字');
    var body = $('[data-cplp-f-body]', this.sheet);
    body.innerHTML = html || '<p class="cplp-fsheet__msg">このコレクションで使える絞り込みはありません</p>';
    this.syncPriceInputs();
    this.setSheetLoading(false);
    this.updateSheet();
  };

  Plp.prototype.updateSheet = function () {
    if (!this.sheet || !this.data || !this.draft) return;
    var self = this, d = this.draft;
    $all('.cplp-opt[data-k]', this.sheet).forEach(function (b) {
      var k = b.dataset.k, v = b.dataset.v, on = d[k].has(v);
      var n = self.countOne(d, k, v);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      $('.cplp-opt__n', b).textContent = n;
      var off = n === 0 && !on;
      b.classList.toggle('is-zero', off);
      if (off) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
    });
    $all('input[type="radio"]', this.sheet).forEach(function (r) { r.checked = r.value === d.sort; });
    var swap = $('[data-cplp-price-swap]', this.sheet);
    if (swap) swap.hidden = !(d.price.min !== null && d.price.max !== null && d.price.min > d.price.max);
    var n = this.compute(d).length;
    var apply = $('[data-cplp-f-apply]', this.sheet);
    $('[data-cplp-f-apply-label]', apply).textContent = n ? n + '件を表示' : '該当する商品がありません';
    apply.disabled = !n;
    $('[data-cplp-f-hint]', this.sheet).hidden = !!n;
    if (!n) {
      var sig = filterList(d).join('|');
      if (sig !== this.zeroSig) {
        this.zeroSig = sig;
        this.publish('callec:plp_filter_zero', { filters: filterList(d) });
      }
    }
  };

  Plp.prototype.applyFromSheet = function () {
    var prev = this.state, next = cloneState(this.draft);
    next.price = normPrice(next.price);
    var filtersChanged = !sameFilters(prev, next), sortChanged = prev.sort !== next.sort;
    this.state = next;
    if (this.sheet && this.sheet.isOpen && this.sheet.isOpen()) this.sheet.closeDrawer();
    var self = this;
    this.apply(true).then(function () {
      if (filtersChanged) {
        self.publish('callec:plp_filter_apply', {
          via: 'sheet', filters: filterList(self.state), result_count: self.results.length || self.cfg.total
        });
      }
      if (sortChanged) self.publish('callec:plp_sort_change', { sort_by: self.state.sort, via: 'sheet' });
    });
    this.scrollToList();
  };

  /* ---------- 操作 ---------- */
  Plp.prototype.removeOne = function (k, v) {
    var f = cloneState(this.state), self = this;
    if (k === 'price') f.price = { min: null, max: null }; else f[k].delete(v);
    this.state = f;
    this.apply(true).then(function () {
      self.publish('callec:plp_filter_apply', {
        via: 'remove_chip', filters: filterList(self.state), result_count: activeCount(self.state) ? self.results.length : self.cfg.total
      });
    });
  };

  Plp.prototype.clearAll = function () {
    var f = emptyState(), self = this;
    f.sort = this.state.sort; // 並び替えは解除しない
    this.state = f;
    this.apply(true).then(function () {
      self.publish('callec:plp_filter_apply', {
        via: 'clear_all', filters: [], result_count: activeCount(self.state) ? self.results.length : self.cfg.total
      });
    });
    this.scrollToList();
  };

  Plp.prototype.onSheetClick = function (e) {
    var more = e.target.closest('[data-cplp-f-showmore]');
    if (more) {
      more.parentNode.classList.add('is-all');
      more.remove();
      return;
    }
    var b = e.target.closest('.cplp-opt[data-k]');
    if (b && this.draft) {
      if (b.getAttribute('aria-disabled') === 'true') return;
      var k = b.dataset.k, v = b.dataset.v;
      if (this.draft[k].has(v)) this.draft[k].delete(v); else this.draft[k].add(v);
      this.updateSheet();
      return;
    }
    if (e.target.closest('[data-cplp-f-reset]') && this.draft) {
      var s = this.draft.sort;
      this.draft = emptyState();
      this.draft.sort = s;
      this.syncPriceInputs();
      this.updateSheet();
      return;
    }
    if (e.target.closest('[data-cplp-f-apply]')) this.applyFromSheet();
  };

  Plp.prototype.bind = function () {
    var self = this;
    var prefetch = function () { self.loadData().catch(function () {}); };
    this.bar.addEventListener('pointerdown', prefetch, { passive: true, once: true });
    this.bar.addEventListener('click', function (e) {
      var open = e.target.closest('[data-cplp-f-open]');
      if (open) self.openSheet(open);
    });
    var sel = $('[data-cplp-f-sort]', this.bar);
    if (sel) {
      sel.addEventListener('change', function () {
        var f = cloneState(self.state);
        f.sort = sel.value;
        self.state = f;
        self.apply(true);
        self.publish('callec:plp_sort_change', { sort_by: f.sort, via: 'select' });
      });
    }
    this.applied.addEventListener('click', function (e) {
      if (e.target.closest('[data-cplp-f-clear]')) { self.clearAll(); return; }
      var c = e.target.closest('[data-rm]');
      if (c) self.removeOne(c.dataset.rm, c.dataset.v);
    });
    this.box.addEventListener('click', function (e) {
      if (e.target.closest('.cplp-fempty [data-cplp-f-clear]')) self.clearAll();
    });
    if (this.sheet) {
      this.sheet.addEventListener('click', function (e) { self.onSheetClick(e); });
      this.sheet.addEventListener('change', function (e) {
        if (e.target.type === 'radio' && self.draft) { self.draft.sort = e.target.value; self.updateSheet(); }
      });
      /* 価格: 入力のたびに件数を数え直す(通信なし) */
      this.sheet.addEventListener('input', function (e) {
        var inp = e.target.closest('[data-cplp-price]');
        if (!inp || !self.draft) return;
        var v = toYen(inp.value);
        var clean = v === null ? '' : String(v);
        if (inp.value !== clean) inp.value = clean;
        var pr = { min: self.draft.price.min, max: self.draft.price.max };
        pr[inp.dataset.cplpPrice] = v;
        self.draft.price = pr;
        self.updateSheet();
      });
      this.sheet.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && e.target.closest('[data-cplp-price]')) {
          e.preventDefault();
          var ap = $('[data-cplp-f-apply]', self.sheet);
          if (ap && !ap.disabled) self.applyFromSheet();
        }
      });
    }
    window.addEventListener('popstate', function () {
      self.state = self.readUrl();
      self.pendingPage = Number(new URLSearchParams(location.search).get('page')) || 1;
      self.apply(false);
    });
  };

  /* アウトレット: 訴求枠が画面外に出たら、カウントダウンをバーの上端に出す */
  Plp.prototype.initCountdown = function () {
    var strip = $('[data-cplp-fbar-cd]', this.bar);
    var hero = document.querySelector('[data-cplp-outlet]');
    if (!strip || !hero || !('IntersectionObserver' in window)) return;
    var cd = hero.querySelector('[data-cplp-cd]');
    var label = $('[data-cplp-fbar-cd-label]', strip), clock = $('[data-cplp-fbar-cd-clock]', strip);
    var away = false, timer = null;
    var sync = function () {
      var on = away && cd && !cd.hidden;
      strip.hidden = !on;
      if (!on) { clearInterval(timer); timer = null; return; }
      label.textContent = (hero.querySelector('[data-cplp-cd-label]') || {}).textContent || '';
      clock.textContent = (hero.querySelector('[data-cplp-cd-clock]') || {}).textContent || '';
      if (!timer) timer = setInterval(sync, 1000);
    };
    new IntersectionObserver(function (en) {
      away = !en[0].isIntersecting;
      sync();
    }).observe(hero);
  };

  Plp.prototype.onData = function () {
    if (this.sheet && this.sheet.isOpen && this.sheet.isOpen()) this.buildSheet();
  };

  Plp.prototype.onDataError = function () {
    if (!this.sheet) return;
    this.sheet.classList.remove('is-loading');
    $('[data-cplp-f-body]', this.sheet).innerHTML =
      '<p class="cplp-fsheet__msg" role="alert">絞り込みを読み込めませんでした。時間をおいてもう一度お試しください</p>';
  };

  Plp.prototype.init = function () {
    this.bind();
    this.initCountdown();
    /* データは「バーに触れた時」「シートを開いた時」「条件付き URL で来た時」だけ読む(ページ表示時には読まない) */
    var fromUrl = this.readUrl(), ready = Promise.resolve();
    if (activeCount(fromUrl)) {
      this.state = fromUrl;
      this.pendingPage = this.urlPage;
      ready = this.apply(false);
    }
    if (this.mc) {
      var self = this;
      this.mc.onFilterMore = function () { self.showPage(false); };
      this.mc.plpSettled(ready);
    }
  };

  /* ---------- 起動 ---------- */
  function start(scope) {
    $all('[data-cplp-fbar]', scope || document).forEach(function (bar) {
      if (bar.__cplp) return;
      bar.__cplp = new Plp(bar);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(); });
  else start();

  /* テーマエディター: 差し替えたセクションの古いシート(body へ移動済み)を片付ける */
  document.addEventListener('shopify:section:unload', function (e) {
    var id = e.detail && e.detail.sectionId;
    if (!id) return;
    $all('[data-cplp-fsheet="' + id + '"]').forEach(function (s) { s.remove(); });
  });
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });

})();
